module.exports = __webpack_public_path__ + "media/images/flags/NU-809804de1dc169da8b1bd13617808631.svg";